import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a22be2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body d-flex flex-column justify-content-center p-0" }
const _hoisted_2 = {
  class: "fs-1 fw-bolder d-flex justify-content-center thumbnail",
  style: {"min-height":"280px","max-height":"280px","box-shadow":"none","border-radius":"0.475rem 0.475rem 0 0","border-bottom":"1px solid #eff2f5"}
}
const _hoisted_3 = { class: "image-slot" }
const _hoisted_4 = { class: "d-flex justify-content-between fs-1 fw-bolder mt-5 px-5" }
const _hoisted_5 = { class: "fs-4 fw-bold mt-2 px-5" }
const _hoisted_6 = { class: "fs-4 fw-bold mt-2 px-5" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-map-marker" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-map-marker" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" No Address")
const _hoisted_11 = { class: "fs-4 fw-bold mt-2 px-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-globe" }, null, -1))
const _hoisted_13 = { class: "fs-4 fw-bold mt-2 px-5" }
const _hoisted_14 = { href: "tel:{{ phoneNumber }}" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-phone-alt" }, null, -1))
const _hoisted_16 = {
  class: "fs-5 mt-5 mb-5 px-5 pb-5",
  style: {"min-height":"60px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Chip = _resolveComponent("Chip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.cardClass]),
    style: {"min-height":"300px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          src: _ctx.agency.business_logo_src,
          class: "align-middle",
          lazy: "",
          fit: "contain",
          style: {"width":"auto","max-width":"100%","height":"auto","max-height":"280px"}
        }, {
          error: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_picture)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_ctx.agency.business_name), 1),
        _createVNode(_component_Chip, {
          type: "success",
          text: `${_ctx.agency.discount}`,
          class: "fs-2 fw-bolder"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.agency.subtitle ? _ctx.agency.subtitle : ' '), 1),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.completeAddress.trim())
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: 
              `https://maps.google.com/?q=` +
              _ctx.completeAddress.trim().replace(/\s/g, '+')
            ,
              target: "_blank"
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.completeAddress), 1)
            ], 8, _hoisted_7))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_9,
              _hoisted_10
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleVisitWebsite && _ctx.handleVisitWebsite(...args)), ["stop"]))
        }, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.agency.business_website ? _ctx.agency.business_website : 'No Website'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("a", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.phoneNumber), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (!_ctx.isReadMore(_ctx.agency.id))
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.getDescription(50)), 1))
          : _createCommentVNode("", true),
        (_ctx.isReadMore(_ctx.agency.id))
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getDescription(0)), 1))
          : _createCommentVNode("", true),
        (_ctx.getDescription(0).length > 50)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.activateReadMore(_ctx.agency.id)), ["stop"])),
              href: "javascript:void(0)"
            }, _toDisplayString(_ctx.toggleCTALabel(_ctx.agency.id)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}